import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CreateEventDisciplinesForm, CreateEventForm } from '../../types';
import { Option } from '../../../inputs/select/options';
import { CategoriesHttpService } from '../../../../services/categories.http';
import { DistancesHttpService } from '../../../../services/distances.http';
import { GroupsHttpService } from '../../../../services/groups.http';
import { Router } from '@angular/router';
import { getCategoryOptionsUtil } from '../../../../utils/getCategoryOptions.util';
import { COLOR_STYLES } from '../../../../constants/constants';
import { ROUTES } from '../../../../constants/routes';

@Component({
  selector: 'app-event-management-sports-and-disciplines',
  templateUrl: './event-management-sports-and-disciplines.component.html',
  styleUrls: ['./event-management-sports-and-disciplines.component.scss'],
})
export class EventManagementSportsAndDisciplinesComponent {
  @Input() innerForm: FormGroup<CreateEventForm>;
  @Input() disciplinesForm: FormGroup<CreateEventDisciplinesForm>;
  @Input() id: string;

  public groupsOptions: Record<number, Option[]> = {};
  public distancesOptions: Record<number, Option[]> = {};
  public categoryOptions: Option[] = [];

  constructor(
    private categoriesService: CategoriesHttpService,
    private distancesService: DistancesHttpService,
    private cdr: ChangeDetectorRef,
    private groupsService: GroupsHttpService,
    private router: Router
  ) {
    this.categoriesService.getUnwrappedCategories().subscribe((categories) => {
      this.categoryOptions = getCategoryOptionsUtil(categories);
    });
  }

  getSportTitleById(id: number): string {
    return (
      this.categoryOptions.find((option) => option.id === id)?.itemName ?? ''
    );
  }

  removeCategory(id: any): void {
    const control = this.innerForm.controls.categories;
    const categories = control.value ?? [];

    control.setValue(categories.filter((catId) => catId !== id));
  }

  getGroupsOptions(sportId: number): Option[] {
    if (!this.groupsOptions[sportId]) {
      this.groupsOptions[sportId] = [];

      this.groupsService.getGroups(sportId).subscribe(({ groups }) => {
        this.groupsOptions[sportId] = groups.map((item) => ({
          id: item.group_id,
          itemName: item.group_title,
        }));

        this.cdr.detectChanges();
      });
    }

    return this.groupsOptions[sportId];
  }

  getDistancesOption(sportId: number): Option[] {
    if (!this.distancesOptions[sportId]) {
      this.distancesOptions[sportId] = [];
      this.distancesService.getDistances(sportId).subscribe((distances) => {
        this.distancesOptions[sportId] = distances.map((item) => ({
          id: item.distance_id,
          itemName: item.distance_title,
        }));

        this.cdr.detectChanges();
      });
    }

    return this.distancesOptions[sportId];
  }

  createCustomDistance(): void {
    this.router.navigate([ROUTES.CMS_DISTANCE_MANAGEMENT]);
  }

  createCustomGroup(): void {
    this.router.navigate([ROUTES.CMS_GROUP_MANAGEMENT]);
  }

  protected readonly COLOR_STYLES = COLOR_STYLES;
}
